<template>
  <a-modal
    v-model:visible="mixVisible"
    :title="
      `${
        mixDetailVisible
          ? (mixParams.mixId ? '修改' : '新增') + '混合商品链接'
          : '混合商品链接配置'
      }`
    "
    @ok="() => {}"
    style="width: 800px;"
  >
    <div>
      <div v-if="mixDetailVisible">
        <div class="df">
          <div class="lh30">
            <span class="red">*</span>混合商品Collection ID：
          </div>
          <div>
            <a-input
              :disabled="mixParams.mixId ? true : false"
              v-model:value="mixParams.colId"
              placeholder="混合商品Collection ID"
              @blur="
                e => {
                  checkMixCol(e.target.value, 1)
                  checkLength('colId', 10)
                }
              "
            />
          </div>
        </div>
        <div class="df mb20">
          <div class="lh30">
            <a-checkbox
              :checked="mixParams.peerShowFlag - 0 ? true : false"
              @change="
                () =>
                  (mixParams.peerShowFlag = mixParams.peerShowFlag - 0 ? 0 : 1)
              "
              >分体是否一行展示</a-checkbox
            >
          </div>
        </div>
        <div>
          <a-table
            :dataSource="mixDataSource"
            :columns="mixDetailColumns"
            :customRow="mixCustomRow"
            :pagination="false"
          >
            <template #headerCell="{ column }">
              <template v-if="column.key === 'colId'">
                <div><span class="red">*</span>collection ID</div>
              </template>
              <template v-if="column.key === 'crossNum'">
                <div><span class="red">*</span>穿插个数</div>
              </template>
            </template>
            <template #bodyCell="{ column, record, index }">
              <template v-if="column.key === 'deal'">
                <a-button type="link" @click="() => addMixDataSource(index)"
                  >新增</a-button
                >

                <a-popconfirm
                  placement="topLeft"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="() => removeMixDataSource(index)"
                >
                  <template #title>
                    <p>是否确定删除？</p>
                  </template>
                  <a-button type="link" v-if="index" danger>删除</a-button>
                </a-popconfirm>
              </template>
              <template v-if="column.key === 'priority'">
                <div class="df cp">
                  <img :src="dragIcon" style="height: 26px;" />
                  <div style="line-height: 26px;">{{ index + 1 }}</div>
                </div>
              </template>
              <template v-if="column.key === 'colId'">
                <a-input
                  v-model:value="record.colId"
                  @blur="
                    e => {
                      checkMixCol(e.target.value, 2)
                      checkLength('colId_', 10, record)
                    }
                  "
                />
              </template>
              <template v-if="column.key === 'crossNum'">
                <a-input-number
                  :min="0"
                  v-model:value="record.crossNum"
                  @blur="
                    e => {
                      checkLength('crossNum', 4, record)
                    }
                  "
                />
              </template>
            </template>
          </a-table>
        </div>
      </div>
      <div v-if="!mixDetailVisible">
        <a-table
          v-if="!mixDetailVisible"
          :dataSource="mixDataList"
          :columns="mixColumns"
          :pagination="false"
          :scroll="{ y: 300 }"
        >
          <template #headerCell="{ column }">
            <template v-if="column.key === 'colId'">
              <div><span class="red">*</span>collection ID</div>
            </template>
            <template v-if="column.key === 'crossNum'">
              <div><span class="red">*</span>穿插个数</div>
            </template>
          </template>
          <template #bodyCell="{ column, index, record, text }">
            <template v-if="column.key === 'deal'">
              <a-popconfirm
                title="是否解除此混合商品链接？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="() => relieveMix({ index, id: record.mixId })"
              >
                <a-button type="link" danger>解除</a-button>
              </a-popconfirm>
            </template>
            <template v-if="column.key === 'priority'">
              <span>{{ text }}</span>
            </template>
            <template v-if="column.key === 'colId'">
              <a-button
                type="link"
                @click="() => mixShowDetail({ ...record })"
                >{{ text }}</a-button
              >
            </template>
            <template v-if="column.key === 'crossNum'">
              <span>{{ text }}</span>
            </template>
          </template>
        </a-table>
        <div class="mt20 tar">
          <a-pagination
            v-model:current="mixPagination.pageNum"
            :total="mixPagination.total"
            @change="getMixList"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <div class="tar">
        <a-button
          type="primary"
          v-if="mixDetailVisible"
          @click="() => saveMixCol(mixParams.mixId ? '修改' : '新增')"
          >{{ `${mixParams.mixId ? '确认修改' : '确认新增'}` }}</a-button
        >
        <a-button
          type="default"
          v-if="mixDataList.length > 0 && mixDetailVisible"
          @click="cancelEditMix"
          >返回</a-button
        >
        <a-button type="primary" v-if="!mixDetailVisible" @click="addMixData"
          >新增混合商品</a-button
        >
      </div>
    </template>
  </a-modal>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
export default {
  setup() {
    const state = reactive({
      dragIcon:
        'https://cdn-image.kapeixi.cn/web/42debfc3-7cc4-4563-97cf-463a8c07d271/drag.png',
      mixDetailColumns: [
        {
          title: '优先级',
          dataIndex: 'priority',
          key: 'priority',
          align: 'center'
        },
        {
          title: 'collection ID',
          dataIndex: 'colId',
          key: 'colId',
          align: 'center'
        },
        {
          title: '穿插个数',
          dataIndex: 'crossNum',
          key: 'crossNum',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'deal',
          key: 'deal',
          align: 'center',
          width: 200,
          fixed: 'right'
        }
      ],
      mixColumns: [
        {
          title: 'mixId',
          dataIndex: 'colId',
          key: 'colId',
          align: 'center'
        },
        {
          title: '标题',
          dataIndex: 'name',
          key: 'name',
          align: 'center'
        },
        {
          title: '最近修改人',
          dataIndex: 'updatorName',
          key: 'updatorName',
          align: 'center'
        },
        {
          title: '最近修改时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'deal',
          key: 'deal',
          align: 'center'
        }
      ]
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.red {
  color: red;
}
</style>
